import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";

// Pages
import HomePage from "./pages/HomePage";
import ClubPage from "./pages/ClubPage";
import FootballPage from "./pages/FootballPage";
import MatchesPage from "./pages/MatchesPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import SponsorsPage from "./pages/SponsorsPage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

// Layout
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster 
          position="top-right" 
          theme="dark"
          toastOptions={{
            style: {
              background: '#0A0A0A',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff'
            }
          }}
        />
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/clube" element={<ClubPage />} />
            <Route path="/futebol" element={<FootballPage />} />
            <Route path="/jogos" element={<MatchesPage />} />
            <Route path="/noticias" element={<NewsPage />} />
            <Route path="/noticias/:id" element={<NewsDetailPage />} />
            <Route path="/patrocinadores" element={<SponsorsPage />} />
            <Route path="/galeria" element={<GalleryPage />} />
            <Route path="/contactos" element={<ContactPage />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/jogos" element={<AdminDashboard section="matches" />} />
              <Route path="/admin/noticias" element={<AdminDashboard section="news" />} />
              <Route path="/admin/plantel" element={<AdminDashboard section="players" />} />
              <Route path="/admin/patrocinadores" element={<AdminDashboard section="sponsors" />} />
              <Route path="/admin/galeria" element={<AdminDashboard section="gallery" />} />
              <Route path="/admin/direcao" element={<AdminDashboard section="direction" />} />
              <Route path="/admin/mensagens" element={<AdminDashboard section="messages" />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
